const { formatMoney } = window.BAO.Utils

class ActiveFacets extends window.BAO.CustomElement({
  SuperClass: HTMLDivElement,
}) {
  constructor () {
    super()

    this.state = {
      root: window.theme.category
        ? window.theme.category.stateLayer.state
        : window.theme.searchResults.stateLayer.state,
      activeFacets: [],
    }

    this.eventBus = window.theme.category
      ? window.theme.category.eventBus
      : window.theme.searchResults.eventBus
  }

  connectedCallback () {
    this.subscribeToEvents()
    this.populateActiveFacets()
  }

  subscribeToEvents () {
    this.eventBus.subscribe('state:activeFacets:updated', () => {
      this.populateActiveFacets()
    })
  }

  populateActiveFacets () {
    this.state.activeFacets = this.state.root.activeFacets

    this.els['active-facets'].element.innerHTML = ''

    this.state.activeFacets.forEach(facet => {
      if (facet.key === 'klevu_price') {
        this.els['active-facets'].element.insertAdjacentHTML(
          'beforeend',
          this.buildPriceRangeHTML(facet),
        )
      } else {
        facet.values.forEach(value => {
          this.els['active-facets'].element.insertAdjacentHTML(
            'beforeend',
            this.buildHTML(facet, value),
          )
        })
      }
    })

    if (this.state.activeFacets.length > 0) {
      this.els['active-facets'].element.insertAdjacentHTML(
        'beforeend',
        this.buildClearAllHTML(),
      )
    }
  }

  buildPriceRangeHTML (facet) {
    return `
    <facet-delete class="clc-ProductGridFacetsTablet_ActiveFacet" data-facet="klevu_price" data-value="${
      facet.values[0]
    } - ${facet.values[1]}">
      <button type="button" class="clc-ProductGridFacetsTablet_Active clc-ProductGridFacetsTablet_ActiveLink">
        ${formatMoney(facet.values[0] * 100)} - ${formatMoney(
      facet.values[1] * 100,
    )}
        <svg class="clc-ProductGridFacetsTablet_ActiveLinkSvg" xmlns="http://www.w3.org/2000/svg">
          <use href="#icon-close" />
        </svg>
      </button>
    </facet-delete>
  `
  }

  buildHTML (facet, label) {
    const capitalizedKey =
      facet.key.charAt(0).toUpperCase() + facet.key.slice(1)

    return `
    <facet-delete class="clc-ProductGridFacetsTablet_ActiveFacet" data-facet="${capitalizedKey}" data-value="${label}">
      <button type="button" class="clc-ProductGridFacetsTablet_Active clc-ProductGridFacetsTablet_ActiveLink">
        ${label}
        <svg class="clc-ProductGridFacetsTablet_ActiveLinkSvg" xmlns="http://www.w3.org/2000/svg">
          <use href="#icon-close" />
        </svg>
      </button>
    </facet-delete>
  `
  }

  buildClearAllHTML () {
    return `
    <facet-delete-all class="clc-ProductGridFacetsTablet_ActiveFacet" ${
      this.state.activeFacets.length === 0 ? 'disabled' : ''
    }>
      <button type="button" class="clc-ProductGridFacetsTablet_Active clc-ProductGridFacetsTablet_ActiveLink">
        ${window.theme.strings.collection.filters.clearAll}

        <svg class="clc-ProductGridFacetsTablet_ActiveLinkSvg" xmlns="http://www.w3.org/2000/svg">
          <use href="#icon-close" />
        </svg>
      </button>
    </facet-delete-all>
  `
  }
}

window.customElements.define('active-facets', ActiveFacets, {
  extends: 'div',
})
